// Bonus lifecycle status (Point 17). Values come from the backend BonusStatusEnum.
// Approved means cleared but NOT yet paid; Paid means it was included in a saved paycheck.
export const BonusStatusEnum = Object.freeze({
  Recommended: 1,
  Approved: 2,
  Rejected: 3,
  Paid: 4,
});

export const BonusStatusEnumLabel = Object.freeze({
  [BonusStatusEnum.Recommended]: "Recommended",
  [BonusStatusEnum.Approved]: "Approved",
  [BonusStatusEnum.Rejected]: "Rejected",
  [BonusStatusEnum.Paid]: "Paid",
});

// AntD Tag colours per status (Approved waiting-for-payroll is visually distinct from Paid).
export const BonusStatusColor = Object.freeze({
  [BonusStatusEnum.Recommended]: "gold",
  [BonusStatusEnum.Approved]: "blue",
  [BonusStatusEnum.Rejected]: "red",
  [BonusStatusEnum.Paid]: "green",
});
